import { render, staticRenderFns } from "./content-detail.vue?vue&type=template&id=63e58c30&scoped=true&"
import script from "./content-detail.vue?vue&type=script&lang=ts&"
export * from "./content-detail.vue?vue&type=script&lang=ts&"
import style0 from "./content-detail.vue?vue&type=style&index=0&id=63e58c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e58c30",
  null
  
)

export default component.exports